<template>
    <a-modal :visible="visible" title="配方分享" :maskClosable="false" :width="800"
        :okButtonProps="{ props: { disabled: !factoryId || !staffId } }" :confirmLoading="confirmLoading" @ok="ok"
        :bodyStyle="{ padding: '32px',paddingTop: '10px' }" :forceRender="true" @cancel="cancel">
        <a-row style="margin-bottom: 10px;">
            <span>选中配方：</span>
            {{selectedProduct.map(item => item.productName + '(V' + item.version + ')').join('、')}}
        </a-row>
        <a-row>分享范围：</a-row>
        <a-row>
            <a-select show-search allow-clear :value="factoryId" placeholder="输入工厂名称" style="width: 30%"
                :filter-option="false" @search="onFactorySearchDebounce" @change="onFactoryChange">
                <a-spin v-if="factoryFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="factory in factoryList" :key="factory.id">
                    {{ factory.name }}
                </a-select-option>
            </a-select>
            <span style="margin: 0 10px;">-</span>
            <a-select show-search allow-clear :value="staffId" placeholder="输入工厂中人员姓名" style="width: 30%"
                :filter-option="onStaffFilterOption" @change="onStaffChange">
                <a-spin v-if="factoryStaffFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="staff in factoryStaffList" :key="staff.staffId">
                    {{ staff.name }}
                </a-select-option>
            </a-select>
        </a-row>
    </a-modal>
</template>

<script>
import _ from "lodash";

export default {
    name: 'ShareModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        selectedProduct: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            factoryList: [],
            searchFactoryName: '',
            factoryFetching: false,
            factoryId: undefined,
            onFactorySearchDebounce: null,

            factoryStaffFetching: false,
            factoryStaffList: [],
            staffId: undefined,

            confirmLoading: false
        };
    },
    mounted() {
        this.onFactorySearchDebounce = _.debounce(this.onFactorySearch, 600);
    },

    methods: {
        async getFactoryList() {
            this.factoryFetching = true;
            const res = await this.$get("/iot-factory/factory/selectFactoryInfoPage", { size: 1000, current: 1, name: this.searchFactoryName });
            if (res.data && res.data?.records) {
                this.factoryList = res.data.records;
            }
            this.factoryFetching = false;
        },
        onFactorySearch(value) {
            this.searchFactoryName = value;
            this.getFactoryList();
        },
        async onFactoryChange(value) {
            if (this.factoryId != value) {
                this.staffId = undefined;
                this.factoryStaffList = [];
            }
            if (this.factoryId == value) {
                return;
            }
            this.factoryId = value;
            if (value == undefined) {
                return;
            }

            this.factoryStaffFetching = true;
            const res = await this.$get("/iot-factory/factorystaff/selectFactoryStaffInfoPage", { size: 1000, current: 1, factoryId: this.factoryId, name: this.searchStaffName });
            if (res.data && res.data?.records) {
                this.factoryStaffList = res.data.records.filter(item => item.status == 0 && (item.animalRootIds != null && item.animalRootIds.length > 0));
            }
            this.factoryStaffFetching = false;
        },
        onStaffFilterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        onStaffChange(value) {
            this.staffId = value;
        },
        ok() {
            this.confirmLoading = true;
            this.$post('/nhf-app/productshare/productShareConfirm', {
                productIdList: this.selectedProduct.map(item => item.id),
                receiveFactoryId: this.factoryId,
                receiveStaffIdList: [this.staffId]
            }).then(res => {
                if (res.code == 200) {
                    this.$message.success('分享成功');
                    this.cancel();
                }
                this.confirmLoading = false;
            });
        },
        cancel() {
            this.factoryId = undefined;
            this.staffId = undefined;
            this.$emit('close');
        }
    }
};
</script>
<style lang="scss" scoped>
.ant-row {
    min-height: 32px;
}
</style>
